import { classNames, useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { DealItemPanelGroupContent } from './DealItemPanelGroupContent';
import { DealItemPanelGroupHeading } from './DealItemPanelGroupHeading';
import { React } from 'libs/react';
import { DealItemPanelGroupFooter } from './DealItemPanelGroupFooter';
import './DealItemPanelGroup.scss';
import { useBreakpoint } from 'components/util/BreakpointProvider';
/**
 * @component DealItemPanelGroup
 * @since 1.0.0
 */
export function DealItemPanelGroup(props) {
    const { style, item, type, configuration, discountRep, collapse, editable, hideSKU, isDeal, itemsGrouped, label, showIncludedOptions, pricingDisplay, pricingParametersDisplay, quantityType, deal, onChangeProposedItem, items, onQuoteItemRemove } = Object.assign({ style: 'normal', editable: true }, props);
    const breakpoint = useBreakpoint();
    const [isCollapse, setCollapse] = useState(collapse);
    useEffect(() => {
        setCollapse(collapse);
    }, [collapse]);
    /**
     * @function onToggle
     * @since 1.0.0
     * @hidden
     */
    function onToggle() {
        setCollapse((isCollapse) => !isCollapse);
    }
    const className = classNames('deal-item-panel-group', 'deal-item-panel-group-' + style, { 'deal-item-panel-group-collapse': isCollapse }, props.className);
    const itemRows = items && items.length > 0 ? items : [item];
    const showCombinedItemFooter = !(itemRows.length > 1 && !editable);
    const renderItemRows = () => itemRows.map((rowItem, rowIndex) => (React.createElement(DealItemPanelGroupContent, { key: rowItem.id, type: type, item: rowItem, configuration: configuration, discountRep: discountRep, editable: editable, isDeal: isDeal, showIncludedOptions: showIncludedOptions, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, quantityType: quantityType, onChangeProposedItem: onChangeProposedItem, itemsGrouped: itemsGrouped, hideTableHeader: itemRows.length > 1 && rowIndex > 0, onQuoteRemove: onQuoteItemRemove ? () => onQuoteItemRemove(rowItem) : undefined })));
    return (React.createElement("div", { className: className },
        React.createElement(DealItemPanelGroupHeading, { type: type, label: label, item: itemRows[0], configuration: configuration, showIncludedOptions: showIncludedOptions, editable: editable, onToggle: onToggle }),
        React.createElement("div", { className: classNames('deal-item-panel-group__content', {
                'deal-item-panel-group__content--quote': !editable
            }) }, editable || (!editable && !breakpoint.isBelow('md')) ? (React.createElement("table", { className: "deal-item-panel-group__content-table" },
            renderItemRows(),
            showCombinedItemFooter && (React.createElement(DealItemPanelGroupFooter, { type: type, item: item, deal: deal, configuration: configuration, editable: editable, quantityType: quantityType, pricingDisplay: pricingDisplay, hideSKU: hideSKU, itemsGrouped: itemsGrouped })),
            props.children)) : (renderItemRows()))));
}
